import { put, call } from 'redux-saga/effects';
import endpoint from "../../const/backend";
const axios = require('axios');

function api(body){
    return axios.post(endpoint+"/dashboard", body , 
        {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}
  
export function* getDashboard(action){
    try{
        const response = yield call(api, action.body);
        yield put({ type: "SUCCESS_GET_DASHBOARD", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_GET_DASHBOARD" })
    }
}


// WEBPACK FOOTER //
// ./src/store/sagas/dashboard.js